import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getBrowserLang } from '@/utils/browserLang'
import { isCN } from '@/utils/channel'
import zhCN from './locales/zh-CN'
import en from './locales/en'

Vue.use(VueI18n)

function resolveInitialLocale() {
  if (!isCN) return 'zh-CN'
  return getBrowserLang()
}

export const i18n = new VueI18n({
  locale: resolveInitialLocale(),
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': zhCN,
    en,
  },
  silentTranslationWarn: true,
})
